// CMS設定データ
// https://docs.google.com/spreadsheets/d/1mnMVLIPp3qK5YX0tgOFZAnUu3OHnlqsXUKQS0U1u350

// 新しいタイプを追加する場合はオブジェクト末尾に追加し、表示順は order の値のみを変更して制御する
export const DOCUMENT_TYPES = Object.freeze({
  government: { name: '官庁・規制', class: '一次', order: 1 },
  company: { name: '企業', class: '一次', order: 2 },
  court_info: { name: '開廷情報', class: '一次', order: 14 },
  public_comment: { name: 'パブコメ', class: '一次', order: 18 },
  diet_deliberation: { name: '国会審議', class: '一次', order: 7 },
  lawsuit: { name: '訴訟', class: '一次', order: 6 },
  industry_association: { name: '業界団体', class: '一次', order: 8 },
  commentary: { name: 'CODE解説', class: '二次', order: 9 },
  magazine_article: { name: '雑誌', class: '二次', order: 12 },
  case_comment: { name: '判例コメント', class: '二次', order: 11 },
  external: { name: '外部サイト記事', class: '二次', order: 15 },
  other: { name: 'その他', class: '二次', order: 16 },
  magazine_toc: { name: '目次', class: '二次', order: 13 },
  editorial: { name: '編集部記事', class: '二次', order: 10 },
  information: { name: 'お知らせ', class: '二次', order: 17 },
  university: { name: '大学・研究', class: '一次', order: 3 },
  public_comment_start: { name: 'パブコメ開始', class: '一次', order: 4 },
  public_comment_result: { name: 'パブコメ結果', class: '一次', order: 5 },
} as const);

export type DocumentTypeKey = keyof typeof DOCUMENT_TYPES;
export const DOCUMENT_TYPE_KEYS = Object.keys(DOCUMENT_TYPES) as Array<DocumentTypeKey>;

export const REGIONS = Object.freeze({
  japan: { name: '日本' },
  usa: { name: 'アメリカ' },
  america: { name: 'カナダ・中南米' },
  'eu-europe': { name: 'EU・欧州' },
  china: { name: '中国' },
  russia: { name: 'ロシア' },
  'asia-pacific': { name: 'アジア（中国以外）・オセアニア' },
  'middle-east': { name: '中東' },
  africa: { name: 'アフリカ' },
} as const);

export type RegionKey = keyof typeof REGIONS;
export const REGION_KEYS = Object.keys(REGIONS) as Array<RegionKey>;

// 有料会員向けの雑誌オプション
export const PREMIUM_MAGAZINE_OPTIONS = Object.freeze({
  nbl: { name: 'NBL', description: '経済と法律を架橋する取引実務の法律ガイド' },
  shiryoban: {
    name: '資料版商事法務',
    description: '総会担当者の知りたいに応える株主総会・開示書類の専門誌',
  },
  junkan: {
    name: '旬刊商事法務',
    description: '会社法・金商法実務をリードする専門誌',
  },
} as const);
export type PremiumMagazineOptionKey = keyof typeof PREMIUM_MAGAZINE_OPTIONS;
export const PREMIUM_MAGAZINE_OPTION_KEYS = Object.keys(
  PREMIUM_MAGAZINE_OPTIONS,
) as Array<PremiumMagazineOptionKey>;
